import React, { useState } from 'react'

import { Spinner } from '../../../App/Components'
import {
  Dashboard,
  DashBoardHeading,
  DashBoardItem,
  OutOfDashBoard,
} from '../../../App/Components/Container/DashBoard/Dashboard'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import {
  AbsenceRequestCardOverview,
  BottomNavigationSetup,
  ProfileDashboardHeading,
  ProfileDoughnutChart,
} from '../../Components'

import { headingStyle } from './style'

export const Profile = () => {
  const [selectedType, setSelectedType] = useState(null)

  const currentUser = useAppSelector(state => state.users.currentUser)
  const establishment = useAppSelector(state => state.establishment.active)

  if (!currentUser) {
    return <Spinner />
  }

  return (
    <Dashboard
      itemColumnCount={1}
      headingStyle={headingStyle}
      css={{ backgroundColor: '#F1F3FB' }}>
      <DashBoardHeading key={'profileHeading'}>
        <ProfileDashboardHeading />
      </DashBoardHeading>

      <DashBoardItem order={-1} key={'profileItem1'}>
        <ProfileDoughnutChart userUuid={currentUser.uuid} />
      </DashBoardItem>

      {establishment &&
      establishment.permissions.includes('absence_requests') ? (
        <DashBoardItem key={'profileItem2'}>
          <AbsenceRequestCardOverview
            onChange={(e: string) => setSelectedType(e)}
            activeType={selectedType}
          />
        </DashBoardItem>
      ) : (
        <></>
      )}
      <OutOfDashBoard key={'profileOutOfDashboard'}>
        <BottomNavigationSetup currentUser={currentUser} />
      </OutOfDashBoard>
    </Dashboard>
  )

  // TODO AbsenceRequestTypeOverview is outdated, needs a different design to be able to show new absencesTypes.
  // return (
  //   <Dashboard
  //     itemColumnCount={1}
  //     headingStyle={headingStyle}
  //     css={{ backgroundColor: '#F1F3FB' }}>
  //     <DashBoardHeading key={'profileHeading'}>
  //       <ProfileDashboardHeading />
  //     </DashBoardHeading>
  //
  //     <DashBoardItem order={-1} key={'profileItem1'}>
  //       <ProfileDoughnutChart userUuid={user.uuid} />
  //     </DashBoardItem>
  //
  //     <DashBoardNews key={'profileNews'}>
  //       <AbsenceRequestTypeOverview
  //         onClick={(e: string) => setSelectedType(e)}
  //       />
  //     </DashBoardNews>
  //
  //     {establishment &&
  //     establishment.permissions.includes('absence_requests') ? (
  //       <DashBoardItem key={'profileItem2'}>
  //         <AbsenceRequestCardOverview
  //           onChange={(e: string) => setSelectedType(e)}
  //           activeType={selectedType}
  //         />
  //       </DashBoardItem>
  //     ) : (
  //       <></>
  //     )}
  //     <OutOfDashBoard key={'profileOutOfDashboard'}>
  //       <BottomNavigationSetup />
  //     </OutOfDashBoard>
  //   </Dashboard>
  // )
}
